<template>
  <v-list :dense="$vuetify.breakpoint.mobile">
    <BuyoutPickupPointListItem
        v-for="(point, index) in buyout.pickupPoints"
        :key="point.id"
        :item="point"
        :need-divider="index < buyout.pickupPoints.length - 1"
    >
    </BuyoutPickupPointListItem>

    <v-list-item v-if="!buyout.pickupPoints.length"
                 two-line
                 @click="$emit('openAdminMessages')">
      <v-list-item-avatar>
        <v-icon class="red--text">mdi-information-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="red--text">Точки отсутствуют</v-list-item-title>
        <v-list-item-subtitle>Обратитесь к вашему организатору, чтобы он указал точки выдачи для Личного Кабинета</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import BuyoutPickupPointListItem from '@/components/BuyoutPickupPointListItem'
export default {
  name: 'BuyoutPickupPointList',
  components: {BuyoutPickupPointListItem},
  props: {
    buyout: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>

</style>